import { INavLink, INavLinkGroup } from '@m365-admin/nav';

export interface SelectedNavValues {
  selectedValue: string | undefined;
  selectedCategoryValue: string | undefined;
}

export const getLinkValue = (link: INavLink, index: number, groupKey: string): string =>
  link.key || link.url || link.href || `${groupKey}-link-${index}`;

const linkMatchesPath = (link: INavLink, pathname: string): boolean => {
  const linkPath = link.href || link.url;
  if (!linkPath) {
    return false;
  }

  const currentPath = pathname.replace(/\/+$/, '');
  const normalizedLinkPath = linkPath.replace(/^\/+|\/+$/g, '');

  if (!normalizedLinkPath) {
    return false;
  }

  if (linkPath.startsWith('/')) {
    return currentPath === linkPath || currentPath.startsWith(`${linkPath}/`);
  }

  return currentPath.endsWith(`/${normalizedLinkPath}`);
};

export const getSelectedNavValues = (
  groups: INavLinkGroup[],
  pathname?: string,
): SelectedNavValues => {
  let selectedValue: string | undefined;
  let selectedCategoryValue: string | undefined;

  groups.forEach((group) => {
    (group.links || []).forEach((link, linkIndex) => {
      const value = getLinkValue(link, linkIndex, group.key);
      if (link.isSelected || (pathname && linkMatchesPath(link, pathname))) {
        selectedValue = value;
      }

      (link.links || []).forEach((childLink, childIndex) => {
        const childValue =
          childLink.key || childLink.url || childLink.href || `${value}-child-${childIndex}`;
        if (childLink.isSelected || (pathname && linkMatchesPath(childLink, pathname))) {
          selectedValue = childValue;
          selectedCategoryValue = value;
        }
      });
    });
  });

  return { selectedValue, selectedCategoryValue };
};
